import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import {
  nextStep,
  setStep,
  addJointApplicationData,
} from "app/lib/store/slices/steps/loanTypesSteps";
import SubTitle from "app/components/common/typography/SubTitle";
import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import InfoTitle from "app/components/common/typography/InfoTitle";
import DynamicFormOne from "app/components/Individual/applicant/personalDetails/DynamicFormOne";
import { PersonalInfoFormStepOne } from "app/utils/applicant/types/types";
interface FormData {
  yourDetails: PersonalInfoFormStepOne;
  coBorrowerDetails: PersonalInfoFormStepOne;
}

const PersonalDetailsSetpOne: React.FC = () => {
  const dispatch = useDispatch();
  const applicationData = useSelector(
    (state: RootState) => state.loanTypesSteps.jointApplication
  );
  const { loanApplication, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const isRefinance = remaingData?.vehicleDetail?.purchaseFrom === "Refinance";

  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
  } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    const { coBorrowerDetails, yourDetails } = data;

    if (
      yourDetails.email?.toLowerCase() ===
      coBorrowerDetails.email?.toLowerCase()
    ) {
      setError("coBorrowerDetails.email", {
        type: "manual",
        message: "Co-borrower's email must be different from your email.",
      });
      return;
    }

    const yourDetailsData = {
      ...((applicationData?.YourDetails as Partial<FormData["yourDetails"]>) ||
        {}),
      ...yourDetails,
      email: yourDetails.email?.toLowerCase(),
    };
    const coBorrowerDetailsData = {
      ...((applicationData?.Coborrower as Partial<
        FormData["coBorrowerDetails"]
      >) || {}),
      ...coBorrowerDetails,
      email: coBorrowerDetails.email?.toLowerCase(),
    };

    dispatch(
      addJointApplicationData({
        category: "YourDetails",
        data: yourDetailsData,
      })
    );
    dispatch(
      addJointApplicationData({
        category: "Coborrower",
        data: coBorrowerDetailsData,
      })
    );

    dispatch(nextStep());
  };

  useEffect(() => {
    if (applicationData?.YourDetails && applicationData?.Coborrower) {
      reset({
        yourDetails: {
          firstName: applicationData.YourDetails.firstName || "",
          lastName: applicationData.YourDetails.lastName || "",
          dateOfBirth: applicationData.YourDetails.dateOfBirth || "",
          email: applicationData.YourDetails.email || "",
        },
        coBorrowerDetails: {
          firstName: applicationData.Coborrower.firstName || "",
          lastName: applicationData.Coborrower.lastName || "",
          dateOfBirth: applicationData.Coborrower.dateOfBirth || "",
          email: applicationData.Coborrower.email || "",
        },
      });
    }
  }, [applicationData, reset]);

  const yourFields: any = [
    {
      type: "text",
      name: "yourDetails.firstName",
      label: "First Name",
      placeholder: "Caroline",
      className: "flex-1",
      rules: {
        required: "First name is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
      required: true,
    },
    {
      type: "text",
      name: "yourDetails.lastName",
      label: "Last Name",
      placeholder: "Jamees",
      className: "flex-1",
      rules: {
        required: "Last name is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
      required: true,
    },
    {
      type: "date",
      name: "yourDetails.dateOfBirth",
      label: "Date Of Birth",
      placeholder: "DD/MM/YYYY",
      className: "flex-1",
      rules: {
        required: "Date is required",
      },
      validateAge: true,
      maxDate: true,
    },
    {
      type: "text",
      name: "yourDetails.email",
      label: "Email address",
      className: "flex-1",
      placeholder: "Caroline325@mail.com",
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
      required: true,
    },
  ];
  const coBorrowerDetailsFields: any = [
    {
      type: "text",
      name: "coBorrowerDetails.firstName",
      label: "First Name",
      placeholder: "Caroline",
      className: "flex-1",
      required: true,
      rules: {
        required: "First name is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
    },
    {
      type: "text",
      name: "coBorrowerDetails.lastName",
      label: "Last Name",
      placeholder: "Jamees",
      className: "flex-1",
      required: true,
      rules: {
        required: "Last name is required",
        pattern: {
          value: /^[A-Za-z\s]+$/,
          message: "Only alphabets are allowed",
        },
      },
    },
    {
      type: "date",
      name: "coBorrowerDetails.dateOfBirth",
      label: "Date Of Birth",
      placeholder: "DD/MM/YYYY",
      className: "flex-1",
      rules: {
        required: "Date is required",
      },
      validateAge: true,
      maxDate: true,
    },
    {
      type: "text",
      name: "coBorrowerDetails.email",
      label: "Email address",
      className: "flex-1",
      placeholder: "Caroline325@mail.com",
      required: true,
      rules: {
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format",
        },
      },
    },
  ];

  return (
    <>
      <ProgressBar progress={60} MB={4} />
      <div className="w-full  sm:w-[70%] xl:w-[40%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Personal Details" />
        <SubTitle title="Please enter the required information below" />
      </div>
      <div className="mx-auto w-internalWidth">
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex mb-5 flex-col md:flex-col xl:flex-row gap-3 sm:gap-4 ">
            <div className="flex-1">
              <InfoTitle title="Your Details" />
              <DynamicFormOne
                fields={yourFields}
                control={control}
                errors={errors}
              />
            </div>
            <div className="flex-1">
              <InfoTitle title="Co-borrower" />
              <DynamicFormOne
                fields={coBorrowerDetailsFields}
                control={control}
                errors={errors}
              />
            </div>
          </div>

          <div className="flex justify-between mb-6">
            <PreviousButtom
              onClick={() => dispatch(setStep(isRefinance ? 7 : 6))}
            >
              Previous
            </PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default PersonalDetailsSetpOne;
